module.exports = __webpack_public_path__ + "img/electronic_pending_zone_selected.23020992.svg";